import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const negativePoints = ['Sin sistema de triage claro: perdés tiempo valioso en la evaluación inicial.', 'Dudás en el manejo de urgencias respiratorias: riesgo de derivación tardía o internación innecesaria.', 'Manejo empírico del lactante febril: exposición a complicaciones graves.', 'Sin protocolo paso a paso para convulsiones: estrés y demoras en la medicación.', 'Documentación deficiente en la guardia: exposición legal máxima ante resultados adversos.', 'Cedes ante la presión de los padres por falta de herramientas de comunicación.', 'Dudas constantes en la rehidratación y manejo digestivo agudo.', 'Sin plantillas de alta segura: los pacientes se van sin pautas de alarma claras.'];
const positivePoints = ['Sistema de triage y TEP automatizado: evaluás la gravedad en segundos.', 'Protocolos claros para bronquiolitis y asma: sabés exactamente cuándo internar y cuándo dar el alta.', 'Algoritmos precisos para fiebre y sepsis: actuás con seguridad clínica.', 'Manejo protocolizado de urgencias neurológicas: medicás rápido y sin errores.', 'Documentación blindada: plantillas legales específicas para la guardia que protegen tu matrícula.', 'Scripts de comunicación: manejás a padres demandantes con autoridad y empatía.', 'Criterios exactos para hidratación y manejo de urgencias digestivas.', 'Protocolos de alta segura: entregás pautas claras y te respaldás legalmente.'];
export function Comparison() {
  const [activeTab, setActiveTab] = useState<'sin' | 'con'>('sin');
  return <section className="bg-slate-100 py-8 sm:py-28" data-id="element-63">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="text-center mb-5 sm:mb-12" data-id="element-65">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-slate-500 uppercase mb-1.5 sm:mb-3" data-id="element-66">
            LA REALIDAD
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-67">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>

        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-sm ring-1 ring-slate-200 overflow-hidden" data-id="element-68">
          <div className="flex flex-row border-b border-slate-200" data-id="element-69">
            <button onClick={() => setActiveTab('sin')} className={`flex-1 py-2.5 px-2 sm:py-4 sm:px-6 text-center text-xs sm:text-lg font-semibold transition-colors ${activeTab === 'sin' ? 'bg-red-50 text-red-700 border-b-2 border-red-500' : 'text-slate-500 hover:bg-slate-50'}`} data-id="element-70">
              ❌ Sin Megapack
            </button>
            <button onClick={() => setActiveTab('con')} className={`flex-1 py-2.5 px-2 sm:py-4 sm:px-6 text-center text-xs sm:text-lg font-semibold transition-colors ${activeTab === 'con' ? 'bg-teal-50 text-teal-700 border-b-2 border-teal-500' : 'text-slate-500 hover:bg-slate-50'}`} data-id="element-71">
              ✅ Con Megapack
            </button>
          </div>

          <div className="p-2 sm:p-4 text-center bg-slate-50 border-b border-slate-100 text-[10px] sm:text-sm text-slate-500" data-id="element-72">
            Tocá las pestañas para comparar
          </div>

          <div className="p-4 sm:p-8 min-h-[280px] sm:min-h-[400px]" data-id="element-73">
            <AnimatePresence mode="wait" data-id="element-74">
              {activeTab === 'sin' ? <motion.div key="sin" initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: 20
            }} transition={{
              duration: 0.3
            }} className="space-y-3 sm:space-y-4" data-id="element-75">
                  {negativePoints.map((point, idx) => <div key={idx} className="flex gap-2 sm:gap-4 items-start" data-id="element-76">
                      <XCircle className="w-4 h-4 sm:w-6 sm:h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-77" />
                      <p className="text-xs sm:text-base text-slate-700 leading-relaxed" data-id="element-78">
                        {point}
                      </p>
                    </div>)}
                </motion.div> : <motion.div key="con" initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="space-y-3 sm:space-y-4" data-id="element-79">
                  {positivePoints.map((point, idx) => <div key={idx} className="flex gap-2 sm:gap-4 items-start" data-id="element-80">
                      <CheckCircle2 className="w-4 h-4 sm:w-6 sm:h-6 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-81" />
                      <p className="text-xs sm:text-base text-slate-700 leading-relaxed font-medium" data-id="element-82">
                        {point}
                      </p>
                    </div>)}
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}